// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Content_wrapper__1aBYx","accordion":"Content_accordion__2zX4g"};